import React from "react";
import Layout from "../../reusables/layout/layout";
import RegisterFormPubModel from "../../Component/registerform/registerPublicModel";

const PaymentRegisterPublic = () => {
  return (
    <div>
      <Layout>
        <RegisterFormPubModel
          examType={"PUBLIC SERVICE REGISTRATION"}
          serviceType={"public service"}
          navigateTo={"/public/payment/login"}
          homeLink={"https://publicservice.examsboard.lagosstate.gov.ng/"}
        />
      </Layout>
    </div>
  );
};

export default PaymentRegisterPublic;
